
/**
 * Определяет базовый URL API на основе текущего окружения
 * Для production/тестового сервера использует переменную окружения или определяет автоматически
 */
export const getApiUrl = () => {
    
    // Если переменная окружения установлена, используем её (приоритет)
    if (process.env.REACT_APP_API) {
        return process.env.REACT_APP_API;
    }
    
    // Определяем API URL на основе текущего домена
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    
    
    // Для production/тестового сервера (law.fishrungames.com)
    if (hostname === 'law.fishrungames.com' || hostname.includes('fishrungames.com')) {
        const url = 'https://law.fishrungames.com/api';
        return url;
    }

    if (hostname === 'jmd.kg' || hostname.includes('jmd.kg')) {
        const url = 'https://api.jmd.kg/api';
        return url;
    }
    
    // Для localhost (development)
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        const url = 'http://localhost:8000/api';
        return url;
    }
    
    // Fallback - используем тот же домен с портом API
    const url = `${protocol}//${hostname}:8000/api`;
    return url;
};

export const ACCOUNT_API = process.env.REACT_APP_ACCOUNT_API;
export const API = getApiUrl();
